import { useState } from "react";
import { Col, Form, Image, Row, FormLabel, FormCheck, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import SessionUtil from "../util/SessionUtil";


function SelectType({page,handleClick}) {
    const { t } = useTranslation(); // Use t instead of lang

    const [val, setVal] = useState('selectUser');
    const [data] = useState([
        { id: "0", type: "Operation", val: "1", img: "/images/operation.png" },
        { id: "1", type: "Finance", val: "2", img: "/images/finance.png" },
        { id: "2", type: "Store", val: "3", img: "/images/store.png" },
        { id: "3", type: "Admin", val: "4", img: "/images/admin.png" },

    ])
    const handleType = (e) => {
        const value = e.target.value
        setVal(value)
       page !== 'register' && SessionUtil.setTypeUser(value);
    }
    return (
        <div>
            <div className="card px-4 py-4 border-c-t">
                <Form>
                    {data.map((item, index) => {
                        return (
                            ((page === 'login' && item.type !== 'Store') || page !== 'login') &&  <Row key={index} className={`flex-nowrap ${item.id > '0' && "pt-3"}` }>
                                <Col xs={1}>
                                    <Image alt="image"   src={item.img} />
                                </Col>
                                <Col xs={11} className={index < data.length - 1 && "before border-b pb-3 overflow-hidden"}>
                                    <div className="d-flex justify-content-between">
                                        <FormLabel htmlFor={item.id} className="mb-0 font-medium">{t(item.type)}</FormLabel>
                                        <FormCheck 
                                            name="selectType"
                                            type={'radio'}
                                            id={item.id}
                                            value={item.val}
                                            onClick={handleType}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        )
                    })}
                </Form>
            </div>

            <Button aria-label="Aria label" onClick={() => handleClick(val)} disabled={val === 'selectUser'} className={`btn-main w-100 mt-4 ${val === 'selectUser' ? "cursor-not-allowed" : ""} `}>{page === "login" ? t("Next to Login") : t("Next to create account")}</Button>
        </div>


    );
}

export default SelectType;
